import type { Object3D } from 'three'
import { ThreeItemKeys } from '../constants/three'
import { convertToSceneUnit, isObjectDxf2D } from './scene-json'

/**
 * Updates DXF layers by cloning the original group for each layer
 *
 * This function takes a DXF 2D object and creates multiple layers
 * by cloning the original geometry and offsetting each clone in the Z direction.
 *
 * @param object - The DXF 2D Object3D to update
 */
export function updateDxfLayers(object: Object3D) {
  if (!isObjectDxf2D(object)) return

  const layers = Math.max(1, Math.floor(object.userData[ThreeItemKeys.LAYERS_AMOUNT]))
  const original = object.children.find(child => child.userData[ThreeItemKeys.IS_ORIGINAL_DXF] === true)

  if (!original) return

  const layerHeight: number = object.userData[ThreeItemKeys.LAYER_HEIGHT]
  object.children = [original]

  // Clone the original group for each additional layer
  for (let i = 1; i < layers; i++) {
    const zOffset = i * (convertToSceneUnit(layerHeight) as number)
    const layerClone = original.clone()

    // Offset the cloned group in Z
    layerClone.position.z = zOffset

    object.add(layerClone)
  }
}
